export function getAudioSeekMax(audio) {
  if (!audio) return 0;
  const dur = audio.duration;
  if (Number.isFinite(dur) && dur > 0) return dur;
  try {
    if (audio.seekable?.length > 0) {
      const end = audio.seekable.end(audio.seekable.length - 1);
      if (Number.isFinite(end) && end > 0) return end;
    }
  } catch {
    /* ignore */
  }
  if (Number.isFinite(dur) && dur === Infinity) return Infinity;
  return 0;
}

/** Whether ± seek controls are likely to work (not live/infinite with no seek range). */
export function canSeekAudio(audio) {
  if (!audio) return false;
  const max = getAudioSeekMax(audio);
  if (Number.isFinite(max) && max > 0 && max !== Infinity) return true;
  if (max === Infinity) {
    try {
      return audio.seekable.length > 0 && audio.seekable.end(audio.seekable.length - 1) > 1;
    } catch {
      return false;
    }
  }
  return false;
}
